import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTermsConditions, selectTermsConditionsPage } from 'store/slices/AdditionalPagesSlice';
import AdditionalPage from 'pages/AdditionalPage';

const TermsAndConditions = () => {
    const dispatch = useDispatch();

    const {
        fs_title,
        fs_background,
        fs_description,
        blocks = [],
        policy_title,
        flyer_file_name,
        flyer_file,
    } = useSelector(selectTermsConditionsPage);

    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchTermsConditions());
    }, [dispatch]);

    const sections = blocks.map(item => ({ block: item }));

    const contentData = [{ pdf: { policy_title, flyer_file_name, flyer_file } }, ...sections];

    return (
        <AdditionalPage
            title={fs_title}
            background={fs_background}
            buttonText={fs_description}
            pageContentData={contentData}
        />
    );
};

export default TermsAndConditions;
